module.exports = __webpack_public_path__ + "static/media/content_tea_shop_1.40a02fc9.png";